module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "vswipe": ""
    }
  }, [_c('div', {
    staticClass: "swipe-wrap"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bec9961c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-bec9961c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Swipe.vue
// module id = 10
// module chunks = 0